import { httpDelete, httpDelete_New, httpGet, httpGetFile, httpPost, httpPut } from './api.service';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { Role } from '../types/Role';
import { SingleResult } from '../types/SingleResult';
import { Result } from '../types/Result';
import { AuthProfile } from '../types/AuthProfile';

const getRoles = async (model: PaginatedRequest): Promise<PaginatedResult<Role>> => await httpGet(`api/auth/role`, model);

const getRole = async (id: string): Promise<SingleResult<Role>> => await httpGet(`api/auth/role/${id}`);

const getAppUserRoles = async (appUserId: string): Promise<Result<Role>> => await httpGet(`api/auth/role/user/${appUserId}`);

const saveRole = async (name: string): Promise<SingleResult<Role>> => await httpPost(`api/auth/role`, name);

const deleteRole = async (id: string): Promise<void> => await httpDelete_New(`api/auth/role/${id}`);

const assignRoles = async (appUserId: string, roleIds: string[]): Promise<SingleResult<AuthProfile>> =>
  await httpPost(`api/user/${appUserId}/roles`, roleIds);

const addPolicyToRole = async (roleId: string, policyId: string): Promise<SingleResult<Role>> =>
  await httpPost(`api/auth/role/${roleId}/policy/${policyId}`);

const removePolicyFromRole = async (roleId: string, policyId: string): Promise<SingleResult<Role>> =>
  await httpDelete(`api/auth/role/${roleId}/policy/${policyId}`);

const removeRoleFromUser = async (appUserId: string, roleId: string): Promise<SingleResult<AuthProfile>> =>
  await httpDelete(`api/user/${appUserId}/role/${roleId}`);

const exportRoles = async (params): Promise<void> => await httpGetFile(`api/auth/role/export`, params);

const setRoleInternalFlag = async (roleId: string, makesUsersInternalUsers: boolean): Promise<SingleResult<Role>> =>
  await httpPut(`api/auth/role/${roleId}`, { makesUsersInternalUsers });

export {
  getRoles,
  getRole,
  getAppUserRoles,
  saveRole,
  deleteRole,
  assignRoles,
  addPolicyToRole,
  removePolicyFromRole,
  removeRoleFromUser,
  exportRoles,
  setRoleInternalFlag,
};
